import 'reflect-metadata'
import { createRoot } from 'react-dom/client'
import { ThemeProvider, CssBaseline, StyledEngineProvider } from '@mui/material'

import App from './App'
import theme from './theme'
import { initializeObservability } from './observability/faro'

initializeObservability()

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StyledEngineProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
